/* eslint-disable */
import React, { useState, useEffect } from "react";
import Wrapper from "../components/Wrapper";
import Option from "../components/Option";
import Button from "../components/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  updateScreenAction,
  addScreenAction,
  backScreenAction,
} from "../actions";
import {
  HOME_SIZE,
  INTENDED_APP,
  IRRIGATION,
  QUESTION5,
  WATER_SOURCE,
  QUESTION6,
  SHOW_MORE,
  IS_MAINS,
} from "../constants";

function Question4({ screens, updateScreen, backScreen }) {
  const [yes, setYes] = useState(false);
  const [no, setNo] = useState(false);

  const [small, setSmall] = useState(false);
  const [medium, setMedium] = useState(false);
  const [large, setLarge] = useState(false);

  const showIrrigationQuestion = screens.answers.INTENDED_APP === "garden";

  const showMainsAvl =
    screens.answers.INTENDED_APP === "house_and_garden" &&
    screens.answers.WATER_SOURCE === "tank_water";

  const showHomeSize =
    screens.answers.INTENDED_APP === "house_and_garden" &&
    screens.answers.WATER_SOURCE === "mains_and_tank";

  const getQuestion = () => {
    if (showIrrigationQuestion) {
      return "4. Will there be an irrigation system running?";
    } else if (showMainsAvl) {
      return "4. Is mains water available?";
    } else {
      return "4. What best describes the size of the home?";
    }
    return "";
  };
  const getDescription = () => {
    if (showIrrigationQuestion) {
      return "An irrigation system controls the delivery of water to your garden. It commonly consists of a controller or tap timer, valves, cable, popup sprays, and sprinklers.";
    } else if (showMainsAvl) {
      return "";
    } else {
      return "Outlets are defined as toilets, garden taps and/or a washing machine.";
    }
    return "";
  };

  const getAnswer = () => {
    if (showIrrigationQuestion) {
      if (yes) {
        return "yes";
      } else {
        return "no";
      }
    } else if (showMainsAvl) {
      if (yes) {
        return "yes";
      } else {
        return "no";
      }
    } else {
      if (small) {
        return "small";
      } else if (medium) {
        return "medium";
      } else {
        return "large";
      }
    }
    return "";
  };

  const getAnswerKey = () => {
    if (showIrrigationQuestion) {
      return IRRIGATION;
    } else if (showMainsAvl) {
      return IS_MAINS;
    } else {
      return HOME_SIZE;
    }
  };
  const homeSizeOpt = [
    {
      name: "1-3 outlets being used at the same time.",
      description: "Small single storey or townhouse.",
      iconName: "small-single-story",
      optionClassName: `${small ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setSmall(true);
        setMedium(false);
        setLarge(false);
      },
    },
    {
      name: "4-5 outlets being used at the same time.",
      description: "Medium single or double storey.",
      iconName: "medium-single-story",
      optionClassName: `${medium ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setSmall(false);
        setMedium(true);
        setLarge(false);
      },
    },
    {
      name: "6 or more outlets being used at the same time.",
      description: "Large house or double storey.",
      iconName: "large-house-or-double",
      optionClassName: `${large ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setSmall(false);
        setMedium(false);
        setLarge(true);
      },
    },
  ];

  const options = [
    {
      name: "Yes",
      iconName: "yes",
      optionClassName: `${yes ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setYes(true);
        setNo(false);
      },
    },

    {
      name: "No",
      iconName: "no",
      optionClassName: `${no ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setYes(false);
        setNo(true);
      },
    },
  ];

  const getOptions = () => {
    if (showHomeSize) {
      return homeSizeOpt;
    } else {
      return options;
    }
  };

  const buttonDisabled = () => {
    let isBtnDisabled;
    if (showIrrigationQuestion || showMainsAvl) {
      isBtnDisabled = !yes && !no;
      return isBtnDisabled;
    } else {
      isBtnDisabled = !small && !medium && !large;
      return isBtnDisabled;
    }
    return false;
  };
  const finalOpt = getOptions();

  useEffect(() => {
    if (showIrrigationQuestion) {
      if (screens.answers.IRRIGATION === "yes") {
        setYes(true);
      }
      if (screens.answers.IRRIGATION === "no") {
        setNo(true);
      }
    }

    if (showMainsAvl) {
      if (screens.answers.IS_MAINS === "yes") {
        setYes(true);
      }
      if (screens.answers.IS_MAINS === "no") {
        setNo(true);
      }
    }

    if (showHomeSize) {
      if (screens.answers.HOME_SIZE === "small") {
        setSmall(true);
      }
      if (screens.answers.HOME_SIZE === "medium") {
        setMedium(true);
      }
      if (screens.answers.HOME_SIZE === "large") {
        setLarge(true);
      }
    }
  }, []);

  return (
    <Wrapper
      stepNo={"4"}
      question={getQuestion()}
      description={getDescription()}
    >
      <div
        className="uk-child-width-expand@s uk-grid-match uk-text-center c-quiz_options"
        uk-grid="margin: uk-margin-small uk-margin@s"
      >
        {finalOpt.map((option) => {
          return (
            <Option
              key={`opt_${option.name}`}
              name={option.name}
              iconName={option.iconName}
              description={option.description}
              optionClassName={option.optionClassName}
              onClick={option.action}
            />
          );
        })}
      </div>

      <Button
        text={"Back"}
        secondary
        onClick={() => {
          backScreen({
            back_screen: INTENDED_APP,
          });
        }}
      />

      <Button
        text={"continue"}
        disabled={buttonDisabled()}
        onClick={() => {
          const ans = getAnswer();
          const key = getAnswerKey();
          if (showIrrigationQuestion && ans === "yes") {
            updateScreen({
              curr_screen: key,
              next_screen: SHOW_MORE,
              answer: ans,
            });
          } else if (showMainsAvl && ans === "no") {
            updateScreen({
              curr_screen: key,
              next_screen: SHOW_MORE,
              answer: ans,
            });
          } else if (showHomeSize) {
            updateScreen({
              curr_screen: key,
              next_screen: QUESTION6,
              answer: ans,
            });
          } else {
            updateScreen({
              curr_screen: key,
              next_screen: QUESTION5,
              answer: ans,
            });
          }
        }}
      />
    </Wrapper>
  );
}
const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      backScreen: backScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Question4);
